import React, { useEffect, useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles, Popper, TextField } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { currentCurrency, changeCurrency } from "../../features/currencySlice";

const useStyles = makeStyles((theme) => ({
  paper: {
    margin: 0,
  },
}));

const CustomPopper = function (props) {
  return (
    <Popper {...props} placement={"bottom-start"} style={{ width: 250 }} />
  );
};

function CurrencySelect({ currency }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const currentCurSelected = useSelector(currentCurrency);

  //console.log(currentCurSelected);

  const [inputValue, setInputValue] = useState(currentCurSelected.symbol);

  const options = currency.map((option, index) => {
    const currencyName = option.id
      .split("-")
      .map((opt) => opt[0].toUpperCase() + opt.substring(1))
      .join(" ");
    return {
      currencyName: currencyName,
      ...option,
    };
  });

  const onCurrencyChange = (e, value) => {
    dispatch(changeCurrency(value));
  };

  return (
    <Autocomplete
      id="currency-group"
      options={options.sort(
        (a, b) => -b.currencyName.localeCompare(a.currencyName)
      )}
      style={{ minWidth: 100 }}
      classes={{
        paper: classes.paper,
      }}
      groupBy={(option) => option.currencyName}
      getOptionLabel={(option) => option.symbol}
      getOptionSelected={(option, value) => option.id === value.id}
      value={currentCurSelected}
      onChange={(e, value, reason) => onCurrencyChange(e, value)}
      inputValue={inputValue}
      onInputChange={(e, newInputValue) => {
        setInputValue(newInputValue);
      }}
      PopperComponent={CustomPopper}
      onFocus={(e) => setInputValue("")}
      openOnFocus={true}
      disableClearable
      blurOnSelect
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={currentCurSelected.symbol}
          variant="outlined"
        />
      )}
    />
  );
}

export default CurrencySelect;
